module.exports = __webpack_public_path__ + "static/media/heart-filled.76356bd5.svg";